// App A has ONE login: the platform-spa Cognito client (the default in
// /__s3p/project.js). Authorization is by group — the Identity Pool maps an
// owner/admin user's `cognito:groups` to an elevated IAM role, so the same
// session can both use the app and administer it. The /admin area just gates
// on whether the signed-in user holds an admin/owner group.

import type { Me } from "@s3p/sdk";

const origin = typeof window !== "undefined" ? window.location.origin : "";

/** OIDC redirect URI for the single login (already registered in Cognito). */
export const REDIRECT_URI = `${origin}/`;

/** Whether the signed-in user holds a platform admin/owner group. The
 *  Identity Pool maps these to an IAM role with the perms the admin actions
 *  need (e.g. writing provision-project tasks to the platform inbox). */
export function isPlatformAdmin(me: Me | null): boolean {
  if (!me) return false;
  return me.groups.some((g) => /owner|admin/i.test(g));
}
